import React, { useState, useEffect, useRef } from 'react'
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, NavLink } from 'react-router-dom'
import { faTrash, faListAlt, faBook } from '@fortawesome/free-solid-svg-icons'
import Modal from 'react-modal';
import '../../../My_Account.css'
import { country_code_array } from '../functions';
import Sidebar from './Sidebar';
import logo from '../../../images/logo-purple.png'
import { Helmet } from 'react-helmet';
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'
import BACKEND_URL from '../../../api';
import { useCountry } from '../../../context/CountryContext';
import loading from '../../../images/spin.gif'

export default function My_parcels() {
  const { currency } = useCountry();

  const trashicn = <FontAwesomeIcon icon={faTrash} />
  const receipticn = <FontAwesomeIcon icon={faListAlt} />
  const invoiceicn = <FontAwesomeIcon icon={faBook} />
  const [parceldetailscount, setparceldetailscount] = useState(0)
  const [parceldetailscontent, setparceldetailscontent] = useState('')
  const [updatedon, setupdatedon] = useState('')
  const [countries, setcountries] = useState(country_code_array);
  const ref = useRef();

  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const [current, setcurrent] = useState(5)
  const [page, setpage] = useState(0)
  const userid = sessionStorage.getItem('userid')
  const [showModal, setShowModal] = useState(true);
  const [order, setorder] = useState()
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpen2, setModalIsOpen2] = useState(false);
  const [receiptLoading, setReceiptLoading] = useState(0);
  const [invoiceLoading, setInvoiceLoading] = useState(0);

  const [parcelcount, setparcelcount] = useState(0)
  const [parcelcount2, setparcelcount2] = useState(0)
  const [parcelcontent, setparcelcontent] = useState('')

  useEffect(() => {
    setShowModal(true);
    fetch(`${BACKEND_URL}/getParcels`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userid: userid, current: "" }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        console.log("getParcels---------", data)
        if (data.parcel && data.parcel.length > 0) {
          setparcelcontent(data.parcel);
          setparcelcount(data.parcel.length);
          setparcelcount2(data.totparcel.length);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setShowModal(false);
      });
  }, [])

  const setModalIsOpenToTrue = (val, i) => {
    setReceiptLoading(i + 1);

    fetch(`${BACKEND_URL}/getParcelDetails`, {
      method: 'POST', // Specify the request method
      headers: {
        'Content-Type': 'application/json', // Set the content type to JSON
      },
      body: JSON.stringify({
        awb: val
      }) // Convert the data to JSON format
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`); // Handle HTTP errors
        }
        return response.json(); // Parse the response as JSON
      })
      .then((data) => {
        console.log("getParcelDetails-------", data); // Log the response data
        setorder(data); // Set the order state
        if (data.parceldetails) {
          setparceldetailscontent(data.parceldetails); // Set parcel details content
          setparceldetailscount(data.parceldetails.length); // Set parcel details count
          setModalIsOpen(true); // Open the modal
          setupdatedon(data.orderdetails.updated_on); // Update the date
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setReceiptLoading(0); // Set receipt loading to 0
      });
  }

  const setModalIsOpenToFalse = () => {
    setModalIsOpen(false)
  }

  const setModalIsOpenToTrue2 = (val, i) => {
    setInvoiceLoading(i + 1);

    fetch(`${BACKEND_URL}/getParcelDetails`, {
      method: 'POST', // Set the request method to POST
      headers: {
        'Content-Type': 'application/json', // Set the content type to JSON
      },
      body: JSON.stringify({
        awb: val
      }) // Convert the data to a JSON string
    })
      .then((response) => {
        if (!response.ok) {
          // Check if the response is not OK (status code is not in the range 200-299)
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json(); // Parse the response body as JSON
      })
      .then((data) => {
        // Handle the parsed data
        setorder(data); // Set the order state
        if (data.parceldetails) {
          setparceldetailscontent(data.parceldetails); // Set parcel details content
          setparceldetailscount(data.parceldetails.length); // Set parcel details count
          setModalIsOpen2(true); // Open the modal
          setupdatedon(data.orderdetails.updated_on); // Update the date
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setInvoiceLoading(0); // Set invoice loading to 0
      });
  }

  const setModalIsOpenToFalse2 = () => {
    setModalIsOpen2(false)
  }

  function nextpage(val1) {
    fetch(`${BACKEND_URL}/getParcels`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userid: userid, current: val1 }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        if (data.parcel && data.parcel.length > 0) {
          if (val1 > page) {
            setcurrent(current + 5);
          }
          if (val1 < page) {
            setcurrent(current - 5);
          }
          setpage(val1);
          setparcelcontent(data.parcel);
          setparcelcount(data.parcel.length);
        }
      })
      .catch((err) => console.log(err));
  }

  const [orderfordel, setorderfordel] = useState()
  function OrderDelete(val) {
    setorderfordel(val)
    window.confirm('Are you sure you wish to delete this item?') ? deleteorder(val) : deleteorder(0)
  }

  function deleteorder(val) {
    if (val > 0) {
      fetch(`${BACKEND_URL}/deleteParcel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          orderid: val
        })
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          return res.json(); // Assuming the response is JSON
        })
        .then((data) => {
          // Handle the response data if needed
          console.log("-------------", data);
          window.location.reload();
        })
        .catch((err) => console.log(err));
    }
  }

  // const navigate=useNavigate()
  function getTracking(val) {

    window.open('/track/' + val, '_blank', 'noopener,noreferrer');
  }

  return (
    <div className="my_parcels">
      <Helmet>
        <title>Shypv | My Parcels</title>
      </Helmet>
      <Tooltip id="deletetool" />
      <Tooltip id="receipttool" />
      <Tooltip id="invoicetool" />
      <Modal isOpen={modalIsOpen} ariaHideApp={false}>
        <button onClick={setModalIsOpenToFalse} style={{ float: "right" }}>x</button>
        <>

          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className=" " id="mypage2">
                  <div className="table-responsive ">
                    <div className="servies-content become_driver last_order thank-you-page">

                      <ReactToPrint content={() => ref.current}>
                        <PrintContextConsumer>
                          {({ handlePrint }) => (
                            <button onClick={handlePrint} className="btn btn-small" style={{ marginBottom: "14px", background: "#3c50e0", color: "#fff" }}>Print</button>
                          )}
                        </PrintContextConsumer>
                      </ReactToPrint>
                      <div className="table-responsive ">
                        {order && order != "" ? (
                          <table ref={ref} id="print_<?php echo xxh; ?>" className="table-bordered table-striped table-hover table product_account" cellPadding={5} cellSpacing={0} border={1} width="100%" style={{ fontFamily: 'arial', margin: 'auto' }}>
                            <thead>
                              <tr><th colSpan={10}>
                                <h3 style={{ textAlign: "center" }}>Receipt</h3></th>
                              </tr>
                              <tr><th colSpan={5} style={{ textAlign: "center" }}><img src={logo} alt="logo" height="50" style={{ marginBottom: "2%" }} />
                              </th>
                                <th colSpan={5}>Receipt No : {order.orderdetails.id}<br />
                                  Date: {updatedon}<br />
                                  Awb No: {order.invoice.awbno}<br />
                                </th>
                              </tr>
                              <tr><th colSpan={10} style={{ textAlign: "center" }}>Shipment Information</th></tr>
                              <tr>
                                <th colSpan={2}>Reference </th>
                                <th colSpan={2}>Origin </th>
                                <th colSpan={2}>Destination </th>
                                <th colSpan={2}>Pcs</th>
                                <th colSpan={2}>Weight(Kg)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td colSpan={2}>Order- {order.orderdetails.id}</td>
                                {order.orderdetails.delivery_from == 'DXB' || order.orderdetails.delivery_from == 'AUH' || order.orderdetails.delivery_from.length > 2 ? (
                                  <><td colSpan={2}>{order.orderdetails.delivery_from} </td>
                                    <td colSpan={2}>{order.orderdetails.delivery_to} </td></>
                                ) : (
                                  <>
                                    <td colSpan={2}>{countries[`${order.orderdetails.delivery_from}`]} </td>
                                    <td colSpan={2}>{countries[`${order.orderdetails.delivery_to}`]}</td>
                                  </>
                                )
                                }

                                <td colSpan={2}>{parceldetailscount}</td>
                                <td colSpan={2}>{order.orderdetails.total_weight}</td>
                              </tr>
                              <tr>
                                <td colSpan={5}><p>Shipper : {order.collection.name}<br />
                                  Address: {order.collection.address}<br />
                                  City: {order.collection.town}<br />
                                  Phone: {order.collection.phone}<br />
                                </p></td>
                                <td colSpan={5}><p>Consignee : {order.delivery.name}<br />
                                  Address: {order.delivery.address}<br />
                                  City: {order.delivery.town}<br />
                                  Phone: {order.delivery.phone}<br />

                                </p></td>
                              </tr>
                              <tr>
                                <td colSpan={5}>
                                  <p style={{ float: 'right', fontSize: '17px !important' }}><b>Invoice Amount:<b /></b></p><b><b>
                                  </b></b></td>
                                <td colSpan={5}>
                                  <p style={{ float: 'right', fontSize: '17px !important' }}><b>{order.invoice.invoice_amount} {currency}</b></p>
                                </td>
                              </tr>
                            </tbody>


                          </table>
                        ) : null
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="modal-footer">
              <button type="button" className="btn btn-default" onClick={setModalIsOpenToFalse}>Close</button>
            </div>
          </div>

        </>
      </Modal>

      {/* commercial incoice */}

      <Modal isOpen={modalIsOpen2} ariaHideApp={false}>
        <button onClick={setModalIsOpenToFalse2} style={{ float: "right" }}>x</button>
        <>

          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className=" " id="mypage2">
                  <div className="table-responsive ">
                    <div className="servies-content become_driver last_order thank-you-page">

                      <ReactToPrint content={() => ref.current}>
                        <PrintContextConsumer>
                          {({ handlePrint }) => (
                            <button onClick={handlePrint} className="btn btn-small" style={{ marginBottom: "14px", background: "#3c50e0", color: "#fff" }}>Print</button>
                          )}
                        </PrintContextConsumer>
                      </ReactToPrint>
                      <div ref={ref} className="table-responsive " style={{ paddingLeft: "3%", paddingRight: "3%" }}>
                        {order && order != "" ? (<>
                          <div className="col-md-12">
                            <h2 style={{ textAlign: 'center' }}>Commercial Invoice</h2>
                            <p><b>AWB No:</b> {order.invoice.awbno} &nbsp;<b>Invoice Date:</b> {updatedon} &nbsp;<b>Invoice No:{order.invoice.awbno}</b>
                            </p>
                          </div>
                          <div className="row" width="100%">
                            <div className="col-md-12">
                              <table style={{ border: 'none', width: "100%" }}>
                                <tbody>
                                  <tr>
                                    <td colSpan={6} style={{ border: 'none' }}><b>SHIP FROM:</b>  <br />
                                      {order.collection.name}<br />
                                      Address: {order.collection.address}<br />
                                      City: {order.collection.town}<br />
                                      Phone: {order.collection.phone}
                                    </td>
                                    <td style={{ border: 'none' }}>&nbsp;&nbsp;</td>
                                    <td style={{ border: 'none' }}>&nbsp;&nbsp;</td>
                                    <td colSpan={6} style={{ border: 'none' }}><b>SHIP TO: </b> <br />
                                      Consignee : {order.delivery.name}<br />
                                      Address: {order.delivery.address}<br />
                                      City: {order.delivery.town}<br />
                                      Phone: {order.delivery.phone}<br />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              <table id="print_<?php echo xxh; ?>" className="table-bordered table-striped table-hover table product_account" cellPadding={5} cellSpacing={0} border={1} width="100%" style={{ fontFamily: 'arial', margin: 'auto', marginTop: "3%" }}>


                                <thead>
                                  <tr>
                                    <th colSpan={2}>Reference</th>
                                    <th colSpan={2}>Origin </th>
                                    <th colSpan={2}>Destination </th>
                                    <th colSpan={2}>Pcs</th>
                                    <th colSpan={2}>Weight(Kg)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td colSpan={2}>Order- {order.orderdetails.id}</td>
                                    {order.orderdetails.delivery_from == 'DXB' || order.orderdetails.delivery_from == 'AUH' || order.orderdetails.delivery_from.length > 2 ? (
                                      <><td colSpan={2}>{order.orderdetails.delivery_from} </td>
                                        <td colSpan={2}>{order.orderdetails.delivery_to} </td></>
                                    ) : (
                                      <>
                                        <td colSpan={2}>{countries[`${order.orderdetails.delivery_from}`]} </td>
                                        <td colSpan={2}>{countries[`${order.orderdetails.delivery_to}`]}</td>
                                      </>
                                    )
                                    }


                                    <td colSpan={2}>{parceldetailscount}</td>
                                    <td colSpan={2}>{order.orderdetails.total_weight}</td>
                                  </tr>


                                </tbody>


                              </table>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-12">
                              <table style={{ border: 'none', marginTop: '3%' }}>
                                <tbody>
                                  <tr>
                                    <td colSpan={6} style={{ border: 'none' }}>Total Goods Value: {order.invoice.invoice_amount} {currency}<br />
                                      Total Invoice Amount: {order.invoice.invoice_amount} {currency}<br />
                                      Currency Code: {currency}<br />
                                      Total Net Weight: {order.invoice.tot_weight}<br />
                                      Total Gross Weight:{order.invoice.tot_weight}kg
                                    </td>
                                    <td style={{ border: 'none' }}>&nbsp;&nbsp;</td>
                                    <td style={{ border: 'none' }}>&nbsp;&nbsp;</td>
                                    <td style={{ border: 'none' }}>&nbsp;&nbsp;</td>
                                    <td colSpan={6} style={{ border: 'none' }}>Total line items: {parceldetailscount}<br />
                                      Duty / tax billing service:<br />
                                      Carrier: DHL<br />
                                      Ultimate Consignee: {order.delivery.name}<br />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div className="row" style={{ marginTop: '4%' }}>
                            <div className="col-md-12">
                              <p>I/We hereby certify that the information contained in the invoice is true and correct and that the contents of this shipment are as stated above.</p>
                            </div>
                          </div>
                          <div className="row" style={{ marginTop: '4%' }}>
                            <div className="col-md-12">
                              <table style={{ border: 'none' }}>
                                <tbody>
                                  <tr>
                                    <td style={{ border: 'none' }}>
                                      <b>Name:</b><br />
                                      <b>Position:</b><br />
                                      <b>Date of Signature:</b>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                        </>
                        ) : null
                        }
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="modal-footer">
              <button type="button" className="btn btn-default" onClick={setModalIsOpenToFalse2}>Close</button>
            </div>
          </div>

        </>
      </Modal>
      <div className="myparctab" style={{ padding: "0" }} >


        <div className="container-fluid" style={{ padding: "0" }} >
          <div className="row1">

            <Sidebar isOpen={isOpen} />

            {/* /#admin-sidebar */}
            <div id="admin-main-control" className="col-md-9 p-x-3 p-y-1" style={{ overflow: "auto", backgroundColor: "#f1f5f9" }}>
              <div style={{ boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)" }}>
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                  <div className="container-fluid" style={{ justifyContent: "space-between" }}>
                    <button className="navbar-toggler button1" type="button" onClick={toggleSidebar}>
                      {
                        isOpen ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            className="bi bi-arrow-bar-left"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            className="bi bi-arrow-bar-right"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"
                            />
                          </svg>
                        )
                      }
                    </button>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                      <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="offset-1 collapse navbar-collapse" id="navbarNav">
                      <ul className="navbar-nav">
                        <>
                          <li className="nav-item">
                            <NavLink activeclassname="active" exact to="/">HOME</NavLink>
                            {/* <Link className="nav-link active"  aria-current="page" exact  to="/">HOME  </Link> */}
                          </li>
                          <li className="nav-item">
                            <NavLink exact to="/track">TRACK</NavLink>
                            {/* <Link className="nav-link" exact  to="/track">TRACK</Link> */}
                          </li>

                          {/* <li className="nav-item">
                                                            <NavLink exact to="/smart-send">SMART SEND</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/your-business">YOUR BUSINESS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/help">HELP</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/become-a-partner">PARTNERS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/parcels-on-demand">HOW IT WORKS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="https://www.tymexlogistics.com/" target="_blank">LOGISTICS</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/client-zone">CLIENT ZONE</NavLink>
                                                        </li> */}
                        </>
                      </ul>
                    </div>
                  </div>
                </nav>
              </div>

              {
                showModal ? (
                  <p style={{ textAlign: "center", marginTop: "2%" }}><img src={loading} style={{ width: "5%" }} /></p>
                ) : (
                  <div style={{ margin: "20px", padding: "20px", backgroundColor: "white", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)", overflowX: "auto" }}>
                    <div className="content-title m-x-auto">
                      <h3 className="comaprison_hedding">My Parcels </h3>
                    </div>

                    <table className="table-custom">
                      <thead className="table-header-row">
                        <tr>
                          <th scope="col">REFERENCE</th>
                          <th scope="col">SEND FROM</th>
                          <th scope="col">SEND TO</th>
                          <th scope="col">STATUS</th>
                          <th scope="col">CREATED</th>
                          <th scope="col">PRICE</th>
                          <th scope="col" colSpan='3'>QUICK SOLUTIONS</th>
                        </tr>
                      </thead>
                      <tbody className="table-body">

                        {
                          [...Array(parcelcount)].map((e, i) => <>
                            {parcelcontent && parcelcontent[i] != '' ? (
                              <tr key={i} className={`table-row ${i % 2 === 1 ? 'odd' : 'even'}`}>
                                <td className="table-cell"><a className="awbtd" onClick={() => getTracking(parcelcontent[i].awbno)}>{parcelcontent[i].awbno}</a></td>
                                {parcelcontent[i].delivery_from == 'DXB' || parcelcontent[i].delivery_from == 'AUH' || parcelcontent[i].delivery_from.length > 2 ? (
                                  <td className="table-cell">{parcelcontent[i].delivery_from}</td>
                                ) : (
                                  <td className="table-cell">{countries[`${parcelcontent[i].delivery_from}`]}</td>
                                )
                                }

                                {parcelcontent[i].delivery_from == 'DXB' || parcelcontent[i].delivery_from == 'AUH' || parcelcontent[i].delivery_from.length > 2 ? (
                                  <td className="table-cell">{parcelcontent[i].delivery_to}</td>
                                ) : (
                                  <td className="table-cell">{countries[`${parcelcontent[i].delivery_to}`]}</td>
                                )
                                }

                                <td className="table-cell">{parcelcontent[i].transit_status}</td>
                                <td className="table-cell">{parcelcontent[i].updated_on}</td>
                                <td className="table-cell">{currency} {parcelcontent[i].total_price}</td>
                                <td className="table-cell"> <a onClick={() => OrderDelete(`${parcelcontent[i].id}`)} style={{ backgroundColor: 'snow', border: 'none', color: '#3c50e1', fontSize: '20px' }} data-tooltip-id="deletetool" data-tooltip-content="Delete"> {trashicn}</a></td>
                                {
                                  receiptLoading - 1 === i ? (
                                    <td className='table-cell' style={{ width: "50px" }}><p style={{ textAlign: "center" }}><img src={loading} style={{ width: "80%" }} /></p></td>
                                  ) : (
                                    <td className="table-cell"> <a onClick={() => setModalIsOpenToTrue(`${parcelcontent[i].awbno}`, i)} className="receipt" style={{ backgroundColor: 'snow', border: 'none', color: '#3c50e1', fontSize: '20px' }} data-tooltip-id="receipttool" data-tooltip-content="Receipt"> {receipticn}</a></td>
                                  )
                                }
                                {
                                  invoiceLoading - 1 === i ? (
                                    <td className='table-cell' style={{ width: "50px" }}><p style={{ textAlign: "center" }}><img src={loading} style={{ width: "80%" }} /></p></td>
                                  ) : (
                                    <td className="table-cell"> <a onClick={() => setModalIsOpenToTrue2(`${parcelcontent[i].awbno}`, i)} className="invoice" style={{ backgroundColor: 'snow', border: 'none', color: '#3c50e1', fontSize: '20px' }} data-tooltip-id="invoicetool" data-tooltip-content="Invoice"> {invoiceicn}</a></td>
                                  )
                                }
                              </tr>
                            ) : null
                            }</>
                          )
                        }
                      </tbody>
                    </table>
                    {
                      parcelcount2 > 0 ? (
                        <div className="pagination-sec fw">
                          <div>
                            <p className="pagination-info">
                              Showing{" "}
                              <span class="font-medium">{page * 5 + 1}</span> {" "}to{" "}
                              {(page * 5 + 5) > parcelcount2 ? (
                                <span className="font-medium">{" "}{parcelcount2}{" "}</span>
                              ) : (
                                <span className="font-medium">
                                  {" "}{page * 5 + 5}{" "}
                                </span>
                              )}{" "}
                              of <span className="font-medium">{parcelcount2}</span> results
                            </p>
                          </div>

                          <nav aria-label="Page navigation">
                            <ul className="pagination">
                              {current > 5 ? (<>

                                <li>
                                  <a onClick={() => nextpage(page - 1)} aria-label="Previous">
                                    <span aria-hidden="true">«</span>
                                  </a>
                                </li>

                                <li>
                                  <a className="page_list" onClick={() => nextpage(page - 1)}>{page}</a>
                                </li>
                              </>
                              )
                                : null}

                              <li>
                                <a className="page_list active" onClick={() => nextpage(page)} >{page + 1}</a>
                              </li>
                              {current < parcelcount2 ? (
                                <>
                                  <li>
                                    <a className="page_list" onClick={() => nextpage(page + 1)}>{page + 2}</a>
                                  </li>
                                  <li>
                                    <a onClick={() => nextpage(page + 1)} aria-label="Next">
                                      <span aria-hidden="true">»</span>
                                    </a>
                                  </li>
                                </>
                              ) : null}
                            </ul>
                          </nav>
                        </div>
                      ) : (
                        <p className="pagination-info" style={{ display: 'flex', justifyContent: 'center', marginTop: "50px", marginBottom: "50px" }}>There is no data</p>
                      )
                    }
                  </div>
                )
              }

            </div> {/* /#admin-main-control */}
          </div> {/* /.row */}
        </div> {/* /.container-fluid */}
      </div >
    </div >
  )
}
